export class ResourceQuota {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "quotaStatus",
            "baseName": "quotaStatus",
            "type": "QuotaStatus",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceQuota.attributeTypeMap;
    }
    constructor() {
    }
}
